import * as React from "react";

export const NotificationsModalIcon = (props: any) => (
  <svg
    width={56}
    height={56}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={4} y={4} width={48} height={48} rx={24} fill="#D1FADF" />
    <path
      d="M36 33h2v2H18v-2h2v-7a8 8 0 0 1 16 0v7Zm-2 0v-7a6 6 0 1 0-12 0v7h12Zm-9 4h6v2h-6v-2Z"
      fill="#333"
    />
    <rect
      x={4}
      y={4}
      width={48}
      height={48}
      rx={24}
      stroke="#ECFDF3"
      strokeWidth={8}
    />
  </svg>
);
